/* SUPERFAN – Fan Deal Days v2. Sin dependencias.
   Precios: replica sf-card.liquid (fdd-25 = -25%, fan-picks-10 = -10%, redondeo al centavo);
   el descuento real lo aplica Shopify en el carrito. */
(function () {
  var root = document.getElementById("fk");
  if (!root || root.__fk) return;
  root.__fk = true;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var T = {
    start: Date.parse(root.getAttribute("data-start")),
    end25: Date.parse(root.getAttribute("data-end25")),
    end10: Date.parse(root.getAttribute("data-end10"))
  };
  var NOW = Date.now();
  var PAGE = 24;

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function money(c) { return "$" + (c / 100).toFixed(2); }
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function img(src, w) { if (!src) return ""; return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 600); }
  function slug(s) { return String(s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""); }
  function cents(v) { return Math.round(parseFloat(v || 0) * 100); }

  /* ---------- Normalización ---------- */
  function fandomOf(p) {
    var v = p.vendor || "", tags = p.tags || [];
    if (/conmebol/i.test(v) || tags.indexOf("CopaAmerica2024") > -1) return "CONMEBOL";
    if (/blue\s*lock/i.test(v)) return "Blue Lock";
    if (/pac-?man/i.test(v)) return "Club América × PAC-MAN";
    if (/club\s*am/i.test(v)) return "Club América";
    if (/chavo|chapul/i.test(v)) return "El Chavo & El Chapulín";
    if (/printify|printful|apliiq|milled|superfan/i.test(v)) return "";
    return v;
  }
  function catOf(p) {
    var t = (p.product_type || "") + " " + p.title;
    if (/hoodie|sweatshirt|crewneck/i.test(t)) return "layers";
    if (/t-?shirt|tee\b|v-?neck|long.?sleeve|jersey|institucional|institutional|copa america (white|black)/i.test(t)) return "tees";
    if (/medal|pins?\b|keychain|trophy|replica|souvenir/i.test(t)) return "collect";
    return "home";
  }
  function cleanTitle(p) {
    var t = String(p.title).split(" | ")[0];
    t = t.replace(/\s*[-–]\s*Official Fan Apparel$/i, "");
    var i = t.indexOf(" - ");
    if (i > 0) {
      var pre = t.slice(0, i).toLowerCase(), v = String(p.vendor || "").toLowerCase().split(" ")[0];
      if (v && pre.indexOf(v) > -1 && t.length - i > 8) t = t.slice(i + 3);
    }
    return t.replace(/^"(.+)"$/, "$1");
  }
  function dealOf(p) {
    var tags = p.tags || [];
    if (tags.indexOf("fdd-combo") > -1) return "kit";
    if (tags.indexOf("fdd-25") > -1) return NOW >= T.start && NOW < T.end25 ? "25" : "";
    if (tags.indexOf("fan-picks-10") > -1) return NOW >= T.start && NOW < T.end10 ? "10" : "";
    return "";
  }
  function norm(p) {
    var deal = dealOf(p);
    if (!deal) return null;
    var vs = p.variants || [], pmin = Infinity, pmax = 0, cmp = null, avail = false;
    vs.forEach(function (v) {
      var c = cents(v.price);
      if (c < pmin) { pmin = c; cmp = v.compare_at_price ? cents(v.compare_at_price) : null; }
      if (c > pmax) pmax = c;
      if (v.available) avail = true;
    });
    if (!avail || !p.images || !p.images.length) return null;
    var price = pmin, was = cmp, pct = 0;
    if (deal === "25" || deal === "10") {
      var f = deal === "25" ? 0.75 : 0.9;
      if (!was || was < pmin) was = pmin;
      price = Math.round(pmin * f);
    }
    if (was && was > price) pct = Math.floor((was - price) * 100 / was);
    else was = null;
    return {
      id: p.id, handle: p.handle, url: R + "products/" + p.handle, title: cleanTitle(p), rawTitle: p.title,
      fandom: fandomOf(p), cat: catOf(p), deal: deal, price: price, was: was, pct: pct, save: was ? was - price : 0,
      from: pmax > pmin, img: p.images[0].src, img2: p.images[1] ? p.images[1].src : "", images: p.images,
      options: p.options || [], variants: vs
    };
  }

  /* ---------- Carga ---------- */
  function load() {
    var coll = root.getAttribute("data-collection"), all = [];
    function page(n) {
      return fetch(R + "collections/" + coll + "/products.json?limit=250&page=" + n, { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (d) { all = all.concat(d.products || []); if ((d.products || []).length === 250 && n < 6) return page(n + 1); return all; });
    }
    return page(1);
  }

  /* ---------- Relojes ---------- */
  var clocks = $$("[data-fk-clock]");
  function tick() {
    var now = Date.now();
    clocks.forEach(function (el) {
      var end = T[el.getAttribute("data-target")] || T.end10;
      var target = now < T.start ? T.start : end;
      var s = Math.max(0, Math.floor((target - now) / 1000));
      var vals = { d: Math.floor(s / 86400), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
      $$("[data-u]", el).forEach(function (b) {
        var v = String(vals[b.getAttribute("data-u")]);
        if (b.textContent !== v) { b.textContent = v; if (!reduce && b.getAttribute("data-u") === "s") { b.classList.remove("is-tick"); void b.offsetWidth; b.classList.add("is-tick"); } }
      });
    });
    $$("[data-fk-left]").forEach(function (el) {
      var end = T[el.getAttribute("data-fk-left")], ms = end - now;
      if (now < T.start) { el.textContent = "Starts Oct 4"; return; }
      if (ms <= 0) { el.textContent = "Ended"; var tk = el.closest(".fk-ticket"); if (tk) tk.classList.add("is-over"); return; }
      var d = Math.floor(ms / 86400000), h = Math.floor(ms % 86400000 / 3600000), m = Math.floor(ms % 3600000 / 60000);
      el.textContent = "Ends in " + (d ? d + "d " : "") + h + "h " + (d ? "" : m + "m");
    });
    $$("[data-fk-progress]").forEach(function (el) {
      var end = T[el.getAttribute("data-fk-progress")], left = Math.max(0, Math.min(1, (end - now) / (end - T.start)));
      el.style.width = (left * 100).toFixed(1) + "%";
    });
    var lbl = $("[data-fk-livelabel]");
    if (lbl) lbl.textContent = now < T.start ? "Starts soon" : now >= T.end10 ? "Ended" : "Live now";
  }
  tick(); setInterval(tick, 1000);

  /* ---------- Subnav fija + scrollspy ---------- */
  var sub = $("[data-fk-subnav]");
  function measureTop() {
    var top = 0, el = document.elementFromPoint(Math.round(window.innerWidth / 2), 2);
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if ((cs.position === "fixed" || cs.position === "sticky") && !root.contains(el)) { top = Math.max(0, el.getBoundingClientRect().bottom); break; }
      el = el.parentElement;
    }
    root.style.setProperty("--fk-top", Math.round(top) + "px");
    if (sub) root.style.setProperty("--fk-subnav", sub.offsetHeight + "px");
  }
  var mtT = null;
  window.addEventListener("scroll", function () { if (mtT) return; mtT = setTimeout(function () { mtT = null; measureTop(); }, 120); }, { passive: true });
  window.addEventListener("resize", measureTop);
  measureTop();
  if ("IntersectionObserver" in window && sub) {
    var spyLinks = $$("[data-fk-spy]", sub);
    var io = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) {
        if (!en.isIntersecting) return;
        spyLinks.forEach(function (a) {
          var on = a.getAttribute("data-fk-spy") === en.target.id;
          a.classList.toggle("is-on", on);
          if (on && a.scrollIntoView && sub.scrollWidth > sub.clientWidth) a.parentNode.scrollTo({ left: a.offsetLeft - 16, behavior: reduce ? "auto" : "smooth" });
        });
      });
    }, { rootMargin: "-45% 0px -50% 0px" });
    spyLinks.forEach(function (a) { var s = document.getElementById(a.getAttribute("data-fk-spy")); if (s) io.observe(s); });
  }

  /* ---------- Carrito ---------- */
  var toast = $("[data-fk-toast]"), toastT = null;
  function showToast(title, sub, image) {
    if (!toast) return;
    $("[data-fk-toast-title]").textContent = title;
    $("[data-fk-toast-sub]").textContent = sub || "";
    var im = $("[data-fk-toast-img]"); if (image) { im.src = img(image, 160); im.hidden = false; } else im.hidden = true;
    toast.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 5000);
  }
  if (toast) $("[data-fk-toast-close]").addEventListener("click", function () { toast.hidden = true; });
  function addToCart(variantId, name, image) {
    return fetch(R + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || "add"); });
      return fetch(R + "?sections=cart-icon-bubble").then(function (x) { return x.json(); }).then(function (s) {
        var bubble = document.getElementById("cart-icon-bubble");
        if (bubble && s["cart-icon-bubble"]) { var tmp = document.createElement("div"); tmp.innerHTML = s["cart-icon-bubble"]; var nu = tmp.querySelector(".shopify-section") || tmp; bubble.innerHTML = nu.innerHTML; }
      }).catch(function () {}).then(function () {
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        showToast("Added to cart", name, image);
      });
    }).catch(function (e) { showToast("Couldn't add this item", e && e.message ? e.message : "Please try again", image); throw e; });
  }

  /* ---------- Spotlight ---------- */
  function spotlight(list) {
    var box = $("[data-fk-spot]"); if (!box || !list.length) return;
    var i = 0, t = null, media = $(".fk-spot__media", box), dots = $("[data-fk-spot-dots]", box);
    dots.innerHTML = list.map(function (_, k) { return '<button type="button" aria-label="Show deal ' + (k + 1) + '"></button>'; }).join("");
    function show(n) {
      i = (n + list.length) % list.length; var p = list[i];
      media.href = p.url;
      media.innerHTML = '<img src="' + img(p.img, 800) + '" alt="' + esc(p.title) + '">';
      $("[data-fk-spot-brand]", box).textContent = p.deal === "kit" ? "Fan Kit · CONMEBOL" : p.fandom;
      $("[data-fk-spot-name]", box).textContent = p.title;
      $("[data-fk-spot-price]", box).innerHTML = (p.from ? "From " : "") + money(p.price) + (p.was ? "<s>" + money(p.was) + "</s>" : "");
      $$("button", dots).forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
      clearTimeout(t); if (!reduce) t = setTimeout(function () { show(i + 1); }, 4200);
    }
    $$("button", dots).forEach(function (d, k) { d.addEventListener("click", function () { show(k); }); });
    box.addEventListener("mouseenter", function () { clearTimeout(t); });
    box.addEventListener("mouseleave", function () { clearTimeout(t); if (!reduce) t = setTimeout(function () { show(i + 1); }, 2500); });
    show(0);
  }

  /* ---------- Fan Kit builder ---------- */
  var ITEM_PRICE = [
    [/tee/i, 2399], [/trophy keychain/i, 1599], [/pins/i, 1299], [/2024 keychain/i, 1795], [/medal/i, 3099], [/acrylic|replica/i, 4999]
  ];
  var TEAM_ORDER = ["Argentina", "Brazil", "Colombia", "Chile", "Ecuador", "Paraguay", "Peru", "Venezuela", "Bolivia", "CONMEBOL"];
  function kitBuilder(kits) {
    var app = $("[data-fk-kit]"); if (!app || !kits.length) { var s = $("#fk-kit"); if (s) s.hidden = true; return; }
    var teams = {};
    kits.forEach(function (k) {
      var t = k.rawTitle, team = t.split(" ")[0];
      if (/^conmebol/i.test(team)) team = "CONMEBOL";
      var nick = (t.match(/"([^"]+)"/) || [])[1] || (team === "CONMEBOL" ? "Institutional" : "");
      var tier = (t.match(/(Starter|Champion|Collector)/) || [])[1] || "Starter";
      var color = /black tee/i.test(t) ? "Black" : "White";
      var items = (t.split(" - ")[1] || "").split(" + ").map(function (s) { return s.trim(); }).filter(Boolean);
      k.kit = { team: team, nick: nick, tier: tier, color: color, items: items };
      (teams[team] = teams[team] || {})[color] = k;
    });
    var names = TEAM_ORDER.filter(function (n) { return teams[n]; }).concat(Object.keys(teams).filter(function (n) { return TEAM_ORDER.indexOf(n) < 0; }));
    var st = { team: teams.Argentina ? "Argentina" : names[0], color: "White", size: null };
    var wrap = $("[data-fk-teams]");
    wrap.innerHTML = names.map(function (n) {
      return '<button type="button" class="fk-team" role="radio" aria-checked="false" data-team="' + esc(n) + '"><i class="fk-flag fk-flag--' + slug(n) + '"></i>' + esc(n === "CONMEBOL" ? "CONMEBOL" : n) + "</button>";
    }).join("");
    var lastPrice = 0;
    function tween(el, to) {
      if (reduce || !lastPrice) { el.textContent = money(to); lastPrice = to; return; }
      var from = lastPrice, t0 = performance.now(); lastPrice = to;
      (function step(t) { var k = Math.min(1, (t - t0) / 450); el.textContent = money(Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3)))); if (k < 1) requestAnimationFrame(step); })(t0);
    }
    function render() {
      var byColor = teams[st.team];
      if (!byColor[st.color]) st.color = byColor.White ? "White" : "Black";
      var k = byColor[st.color], kit = k.kit;
      $$(".fk-team", wrap).forEach(function (b) { b.setAttribute("aria-checked", b.getAttribute("data-team") === st.team ? "true" : "false"); });
      $$("[data-color]", app).forEach(function (b) { var c = b.getAttribute("data-color"); b.disabled = !byColor[c]; b.setAttribute("aria-checked", c === st.color ? "true" : "false"); });
      $(".fk-kit__img", app).innerHTML = '<img src="' + img(k.img, 1200) + '" alt="' + esc(kit.team + " " + kit.tier + " Fan Kit: " + kit.items.join(", ")) + '">';
      var tierEl = $("[data-fk-kit-tier]", app); tierEl.hidden = false; tierEl.textContent = kit.tier + " kit"; tierEl.setAttribute("data-tier", kit.tier);
      var thumbs = [k.images[1], k.images[3], k.images[4]];
      var sep = 0;
      $("[data-fk-items]", app).innerHTML = kit.items.map(function (name, n) {
        var pr = 0; ITEM_PRICE.some(function (r) { if (r[0].test(name)) { pr = r[1]; return true; } return false; });
        sep += pr;
        var th = thumbs[n] ? '<img src="' + img(thumbs[n].src, 120) + '" alt="" loading="lazy">' : "<img alt=\"\">";
        return "<li>" + th + "<span>" + esc(name) + "</span><em>" + (pr ? money(pr) : "") + "</em></li>";
      }).join("");
      if (!sep && k.was) sep = k.was;
      $("[data-fk-sep]", app).textContent = money(sep);
      tween($("[data-fk-kitprice]", app), k.price);
      var save = sep - k.price;
      $("[data-fk-save]", app).textContent = save > 0 ? "You save " + money(save) + " (" + Math.round(save * 100 / sep) + "%) vs buying separately" : "";
      var sz = $("[data-fk-sizes]", app);
      var stillOk = k.variants.some(function (v) { return v.id === st.size && v.available; });
      if (!stillOk) st.size = null;
      sz.innerHTML = k.variants.map(function (v) {
        return '<button type="button" class="fk-size" role="radio" data-v="' + v.id + '" aria-checked="' + (v.id === st.size) + '"' + (v.available ? "" : " disabled") + ">" + esc(v.title) + "</button>";
      }).join("");
      var btn = $("[data-fk-kit-add]", app);
      btn.disabled = !st.size;
      btn.textContent = st.size ? "Add " + kit.team + " " + kit.tier + " Kit · " + money(k.price) : "Pick a size to continue";
      $("[data-fk-kit-link]", app).href = k.url;
    }
    app.addEventListener("click", function (e) {
      var t = e.target.closest("[data-team]"); if (t) { st.team = t.getAttribute("data-team"); render(); return; }
      var c = e.target.closest("[data-color]"); if (c && !c.disabled) { st.color = c.getAttribute("data-color"); render(); return; }
      var s = e.target.closest(".fk-size"); if (s && !s.disabled) { st.size = parseInt(s.getAttribute("data-v"), 10); render(); return; }
      var a = e.target.closest("[data-fk-kit-add]");
      if (a && !a.disabled) {
        var k = teams[st.team][st.color], label = a.textContent;
        a.disabled = true; a.textContent = "Adding…";
        var vt = (k.variants.filter(function (v) { return v.id === st.size; })[0] || {}).title || "";
        addToCart(st.size, k.kit.team + " " + k.kit.tier + " Fan Kit · " + vt, k.img)
          .then(function () { a.textContent = "Added ✓"; }, function () { a.textContent = label; })
          .then(function () { setTimeout(function () { render(); }, 1600); });
      }
    });
    render();
  }

  /* ---------- Fandoms ---------- */
  var S = { deal: "", cat: "", price: "", fandom: "", sort: "featured", shown: PAGE };
  function groupsOf(list) {
    var g = {};
    list.forEach(function (p) {
      if (!p.fandom) return;
      var x = g[p.fandom] = g[p.fandom] || { name: p.fandom, items: [], min: Infinity, pct: 0 };
      x.items.push(p); if (p.price < x.min) x.min = p.price;
      var d = p.deal === "25" ? 25 : p.deal === "10" ? 10 : 0; if (d > x.pct) x.pct = d;
    });
    return Object.keys(g).map(function (k) { return g[k]; }).sort(function (a, b) {
      if (a.name === "CONMEBOL") return -1; if (b.name === "CONMEBOL") return 1; return b.items.length - a.items.length;
    });
  }
  function fandoms(groups) {
    var box = $("[data-fk-fandoms]"); if (!box) return;
    box.innerHTML = groups.map(function (g) {
      var pics = [], seen = {};
      g.items.forEach(function (p) { if (pics.length < 3 && !seen[p.title]) { seen[p.title] = 1; pics.push(p.img); } });
      return '<button type="button" class="fk-fan" aria-pressed="false" data-fandom="' + esc(g.name) + '">' +
        '<span class="fk-fan__mosaic">' + pics.map(function (s, n) { return '<img src="' + img(s, n ? 300 : 500) + '" alt="" loading="lazy">'; }).join("") + "</span>" +
        '<span class="fk-fan__name">' + esc(g.name) + "</span>" +
        '<span class="fk-fan__meta"><span>' + g.items.length + " designs · from " + money(g.min) + '</span><span class="fk-fan__pct">−' + g.pct + "%</span></span></button>";
    }).join("");
    box.addEventListener("click", function (e) {
      var b = e.target.closest("[data-fandom]"); if (!b) return;
      var f = b.getAttribute("data-fandom");
      S.fandom = S.fandom === f ? "" : f; S.shown = PAGE;
      if (S.fandom === "CONMEBOL") S.deal = "";
      apply();
      if (S.fandom) document.getElementById("fk-shop").scrollIntoView({ behavior: reduce ? "auto" : "smooth" });
    });
  }

  /* ---------- Explorador ---------- */
  var LIST = [], grid = $("[data-fk-grid]"), moreBtn = $("[data-fk-more]");
  var CAT_LABEL = { tees: "Tees", layers: "Hoodies & sweatshirts", collect: "Collectibles", home: "Home & accessories" };
  var PRICE_LABEL = { "20": "Under $20", "40": "$20 – $40", "99": "$40+" };
  function interleave(list) {
    var by = {}, keys = [];
    list.forEach(function (p) { if (!by[p.fandom]) { by[p.fandom] = []; keys.push(p.fandom); } by[p.fandom].push(p); });
    var out = [], more = true, i = 0;
    while (more) { more = false; keys.forEach(function (k) { if (by[k][i]) { out.push(by[k][i]); more = true; } }); i++; }
    return out;
  }
  function filtered() {
    var r = LIST.filter(function (p) {
      if (S.deal && p.deal !== S.deal) return false;
      if (S.cat && p.cat !== S.cat) return false;
      if (S.fandom && p.fandom !== S.fandom) return false;
      if (S.price === "20" && p.price >= 2000) return false;
      if (S.price === "40" && (p.price < 2000 || p.price > 4000)) return false;
      if (S.price === "99" && p.price <= 4000) return false;
      return true;
    });
    if (S.sort === "low") r.sort(function (a, b) { return a.price - b.price; });
    else if (S.sort === "high") r.sort(function (a, b) { return b.price - a.price; });
    else if (S.sort === "save") r.sort(function (a, b) { return b.save - a.save; });
    else if (!S.fandom) r = interleave(r);
    return r;
  }
  var SW = { white: "#fff", black: "#111", navy: "#1f2a44", "true navy": "#1f2a44", red: "#c8102e", "heather grey": "#b7b9bb", grey: "#9aa0a6", gray: "#9aa0a6", "dark grey heather": "#4b4f54", "dark heather": "#4b4f54", "sport grey": "#a7a9ac", "athletic heather": "#b9b9b9", royal: "#2251a3", "royal blue": "#2251a3", pink: "#f4a6c1", "light pink": "#f8c8d8", yellow: "#f6d743", green: "#2e7d32", "kelly green": "#1f9d55", "forest green": "#1e4d2b", maroon: "#6d1f2b", purple: "#5b2a86", orange: "#f28c28", sand: "#d8c8a8", natural: "#efe6d2", "light blue": "#9cc3e6", "baby blue": "#b5d3ee", brown: "#6b4f3a", charcoal: "#36454f", ash: "#d3d6d4" };
  function colorOf(p) { var i = -1; p.options.forEach(function (o, k) { if (/colou?r/i.test(o.name)) i = k; }); if (i < 0) return ""; var v = p.variants[0] && p.variants[0]["option" + (i + 1)]; return v || ""; }
  function swatches(p) {
    if (!p.alts || p.alts.length < 2) return "";
    return '<span class="fk-sws" role="group" aria-label="Other colors">' + p.alts.map(function (a) {
      var c = colorOf(a), known = c && c.split("/").every(function (x) { return SW[x.trim().toLowerCase()]; }), bg = known ? c.split("/").map(function (x) { return SW[x.trim().toLowerCase()]; }) : [];
      var st = !known ? "background:#fff url(" + img(a.img, 80) + ") center/cover" : bg.length > 1 ? "background:linear-gradient(135deg," + bg[0] + " 50%," + bg[1] + " 50%)" : "background:" + bg[0];
      if (!c) c = "Option " + (p.alts.indexOf(a) + 1);
      return '<button type="button" class="fk-sw2' + (a === p ? " is-on" : "") + '" data-fk-swatch="' + a.id + '" title="' + esc(c) + '" aria-label="' + esc(c) + '" aria-pressed="' + (a === p) + '" style="' + st + '"></button>';
    }).join("") + "</span>";
  }
  function card(p) {
    var badge = p.pct ? '<span class="fk-badge">−' + p.pct + "%</span>" : "";
    return '<article class="fk-card" data-id="' + p.id + '"><div class="fk-card__m">' +
      '<a class="fk-card__media" href="' + p.url + '" aria-label="' + esc(p.title) + '">' + badge +
      '<img src="' + img(p.img, 600) + '" alt="' + esc(p.title) + '" loading="lazy">' + (p.img2 ? '<img src="' + img(p.img2, 600) + '" alt="" loading="lazy">' : "") + "</a>" +
      '<button type="button" class="fk-quick" data-fk-quick="' + p.id + '" aria-label="Quick add ' + esc(p.title) + '"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></button></div>' +
      '<span class="fk-card__brand">' + esc(p.fandom) + "</span>" +
      '<a class="fk-card__title" href="' + p.url + '">' + esc(p.title) + "</a>" +
      '<span class="fk-card__price">' + (p.from ? "<small>From</small>" : "") + money(p.price) + (p.was ? "<s>" + money(p.was) + "</s>" : "") + "</span>" + swatches(p) + "</article>";
  }
  function setPressed(group, v) { $$('[data-fk-group="' + group + '"] button').forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-v") === v ? "true" : "false"); }); }
  function apply() {
    setPressed("deal", S.deal); setPressed("cat", S.cat); setPressed("price", S.price);
    var sel = $("[data-fk-fsel]"); if (sel) sel.value = S.fandom;
    $$("[data-fandom]").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-fandom") === S.fandom ? "true" : "false"); });
    var r = filtered();
    $("[data-fk-count]").textContent = r.length;
    $("[data-fk-count-label]").textContent = r.length === 1 ? "design" : "designs";
    grid.innerHTML = r.slice(0, S.shown).map(card).join("");
    $("[data-fk-empty]").hidden = r.length > 0;
    moreBtn.hidden = r.length <= S.shown;
    moreBtn.textContent = "Show more deals (" + (r.length - Math.min(S.shown, r.length)) + " left)";
    var act = $("[data-fk-active]"), chips = [];
    if (S.fandom) chips.push(["fandom", S.fandom]);
    if (S.deal) chips.push(["deal", S.deal === "25" ? "CONMEBOL −25%" : "Fan Picks −10%"]);
    if (S.cat) chips.push(["cat", CAT_LABEL[S.cat]]);
    if (S.price) chips.push(["price", PRICE_LABEL[S.price]]);
    act.hidden = !chips.length;
    act.innerHTML = chips.map(function (c) { return '<button type="button" data-fk-unset="' + c[0] + '" aria-label="Remove filter ' + esc(c[1]) + '">' + esc(c[1]) + "</button>"; }).join("") +
      (chips.length > 1 ? '<button type="button" class="fk-clear" data-fk-reset>Clear all</button>' : "");
  }
  function explorer(list, groups) {
    LIST = list;
    var row = $(".fk-filters__row");
    var sel = document.createElement("label"); sel.className = "fk-select";
    sel.innerHTML = '<span class="fk-vh">Fandom</span><select data-fk-fsel><option value="">All fandoms</option>' +
      groups.map(function (g) { return '<option value="' + esc(g.name) + '">' + esc(g.name) + " (" + g.items.length + ")</option>"; }).join("") + "</select>";
    row.insertBefore(sel, row.lastElementChild);
    root.addEventListener("change", function (e) {
      if (e.target.matches("[data-fk-fsel]")) { S.fandom = e.target.value; S.shown = PAGE; apply(); }
      if (e.target.matches("[data-fk-sort]")) { S.sort = e.target.value; S.shown = PAGE; apply(); }
    });
    root.addEventListener("click", function (e) {
      var b = e.target.closest("[data-fk-group] button");
      if (b) { S[b.parentNode.getAttribute("data-fk-group")] = b.getAttribute("data-v"); S.shown = PAGE; apply(); return; }
      var u = e.target.closest("[data-fk-unset]"); if (u) { S[u.getAttribute("data-fk-unset")] = ""; apply(); return; }
      if (e.target.closest("[data-fk-reset]")) { S.deal = S.cat = S.price = S.fandom = ""; S.shown = PAGE; apply(); return; }
      var g = e.target.closest("[data-fk-go]");
      if (g) { try { var o = JSON.parse(g.getAttribute("data-fk-go")); for (var k in o) S[k] = o[k]; S.shown = PAGE; apply(); } catch (x) {} }
    });
    moreBtn.addEventListener("click", function () { S.shown += PAGE; apply(); });
    var h = (location.hash || "").replace("#", "");
    if (h === "fdd-25") S.deal = "25"; else if (h === "fdd-10") S.deal = "10";
    apply();
  }

  /* ---------- Quick add con selector de talle/color ---------- */
  var BY_ID = {};
  function closePick() { $$(".fk-pick").forEach(function (x) { x.remove(); }); }
  function pickFor(p, chosen) {
    var n = chosen.length, opt = p.options[n];
    var vals = [];
    p.variants.forEach(function (v) {
      var ok = true; for (var i = 0; i < n; i++) if (v["option" + (i + 1)] !== chosen[i]) ok = false;
      if (!ok) return;
      var val = v["option" + (n + 1)], ex = vals.filter(function (x) { return x.v === val; })[0];
      if (!ex) vals.push({ v: val, a: v.available }); else if (v.available) ex.a = true;
    });
    return { name: opt ? opt.name : "Option", vals: vals };
  }
  function openPick(cardEl, p, chosen) {
    closePick();
    var step = pickFor(p, chosen);
    var div = document.createElement("div"); div.className = "fk-pick";
    div.innerHTML = "<p><span>Choose " + esc(step.name.toLowerCase()) + (chosen.length ? " · " + esc(chosen.join(" / ")) : "") + '</span><button type="button" data-fk-pick-x aria-label="Close">×</button></p><div class="fk-pick__opts">' +
      step.vals.map(function (x) { return '<button type="button" data-fk-opt="' + esc(x.v) + '"' + (x.a ? "" : " disabled") + ">" + esc(x.v) + "</button>"; }).join("") + "</div>";
    $(".fk-card__m", cardEl).appendChild(div);
    div.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      if (e.target.closest("[data-fk-pick-x]")) { closePick(); return; }
      var o = e.target.closest("[data-fk-opt]"); if (!o || o.disabled) return;
      var next = chosen.concat([o.getAttribute("data-fk-opt")]);
      if (next.length < p.options.length) { openPick(cardEl, p, next); return; }
      var v = p.variants.filter(function (v) { for (var i = 0; i < next.length; i++) if (v["option" + (i + 1)] !== next[i]) return false; return true; })[0];
      if (!v) return;
      o.classList.add("is-busy"); o.textContent = "Adding…";
      addToCart(v.id, p.title + " · " + v.title, p.img).then(closePick, closePick);
    });
  }
  root.addEventListener("click", function (e) {
    var sw = e.target.closest("[data-fk-swatch]");
    if (sw) { var np = BY_ID[sw.getAttribute("data-fk-swatch")], art = sw.closest(".fk-card"); if (np && art) { var tmp = document.createElement("div"); tmp.innerHTML = card(np); art.parentNode.replaceChild(tmp.firstChild, art); } return; }
    var q = e.target.closest("[data-fk-quick]");
    if (!q) { if (!e.target.closest(".fk-pick")) closePick(); return; }
    e.preventDefault();
    var p = BY_ID[q.getAttribute("data-fk-quick")]; if (!p) return;
    var avail = p.variants.filter(function (v) { return v.available; });
    if (avail.length === 1 && (p.variants.length === 1 || p.options.length === 1 && p.options[0].name === "Title")) {
      q.disabled = true; addToCart(avail[0].id, p.title, p.img).then(function () { q.disabled = false; }, function () { q.disabled = false; });
      return;
    }
    openPick(q.closest(".fk-card"), p, []);
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closePick(); if (toast) toast.hidden = true; } });

  /* ---------- Gift finder ---------- */
  function giftFinder(list, groups) {
    var box = $("[data-fk-gf]"); if (!box) return;
    var gs = { fandom: null, budget: null };
    $("[data-fk-gf-fandom]", box).innerHTML = groups.slice(0, 9).map(function (g) { return '<button type="button" data-v="' + esc(g.name) + '" aria-pressed="false">' + esc(g.name) + "</button>"; }).join("") +
      '<button type="button" data-v="*" aria-pressed="false">Not sure yet</button>';
    function run() {
      $$("[data-fk-gf-fandom] button", box).forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-v") === gs.fandom ? "true" : "false"); });
      $$("[data-fk-gf-budget] button", box).forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-v") === gs.budget ? "true" : "false"); });
      var out = $("[data-fk-gf-result]", box);
      if (!gs.fandom || !gs.budget) { out.innerHTML = ""; return; }
      var cap = parseInt(gs.budget, 10) * 100;
      var pool = list.filter(function (p) { return (gs.fandom === "*" || p.fandom === gs.fandom) && p.price <= cap; });
      pool.sort(function (a, b) { return b.save - a.save || b.price - a.price; });
      var picks = [], cats = {};
      pool.forEach(function (p) { if (picks.length < 3 && !cats[p.cat + p.title]) { if (!cats[p.cat] || pool.length < 6) { picks.push(p); cats[p.cat] = 1; cats[p.cat + p.title] = 1; } } });
      pool.forEach(function (p) { if (picks.length < 3 && picks.indexOf(p) < 0) picks.push(p); });
      if (!picks.length) { out.innerHTML = '<p class="fk-gf__note">Nothing in that budget for this fandom yet. Try a higher budget or "Not sure yet".</p>'; return; }
      out.innerHTML = picks.map(function (p) {
        return '<a class="fk-gf__pick" href="' + p.url + '"><img src="' + img(p.img, 200) + '" alt="" loading="lazy"><div><b>' + esc(p.title) + "</b><span>" + money(p.price) + (p.was ? "<s>" + money(p.was) + "</s>" : "") + '</span></div><span class="fk-gf__go">View →</span></a>';
      }).join("") + (pool.length > 3 ? '<p class="fk-gf__note">' + pool.length + ' matches. <a href="#fk-shop" data-fk-gf-all style="text-decoration:underline">See them all</a></p>' : "");
    }
    box.addEventListener("click", function (e) {
      var f = e.target.closest("[data-fk-gf-fandom] button"); if (f) { gs.fandom = f.getAttribute("data-v"); run(); return; }
      var b = e.target.closest("[data-fk-gf-budget] button"); if (b) { gs.budget = b.getAttribute("data-v"); run(); return; }
      if (e.target.closest("[data-fk-gf-all]")) {
        S.fandom = gs.fandom === "*" ? "" : gs.fandom; S.deal = ""; S.cat = "";
        S.price = gs.budget === "20" ? "20" : ""; S.sort = "save"; var so = $("[data-fk-sort]"); if (so) so.value = "save"; S.shown = PAGE; apply();
      }
    });
  }

  /* ---------- Arranque ---------- */
  load().then(function (raw) {
    var seen = {}, list = [], kits = [];
    raw.forEach(function (p) {
      var n = norm(p); if (!n) return;
      if (n.deal === "kit") { kits.push(n); return; }
      if (!n.fandom) return;
      BY_ID[n.id] = n;
      var key = n.fandom + "|" + n.title.toLowerCase();
      if (seen[key]) { seen[key].alts.push(n); n.alts = seen[key].alts; return; }
      n.alts = [n]; seen[key] = n; list.push(n);
    });
    var groups = groupsOf(list);
    kitBuilder(kits);
    fandoms(groups);
    explorer(list, groups);
    giftFinder(list, groups);
    var spot = [], used = {};
    kits.some(function (k) { if (/argentina/i.test(k.rawTitle) && /black/i.test(k.rawTitle)) { spot.push(k); return true; } return false; });
    list.slice().sort(function (a, b) { return b.save - a.save; }).forEach(function (p) { if (spot.length < 6 && !used[p.fandom]) { used[p.fandom] = 1; spot.push(p); } });
    spotlight(spot);
    measureTop();
  }).catch(function () {
    grid.innerHTML = '<p class="fk-empty">We couldn\'t load the deals. <a href="' + R + 'collections/all">Browse the store</a>.</p>';
  });
})();
